import { hasRequiredFields } from '@move-frontend/utils';
import { useCreateUserAccountFormContext } from './useCreateUserAccountFormContext';

export function useCreateUserAccountHasRequiredFields() {
	const { watch } = useCreateUserAccountFormContext();
	const values = watch();

	return hasRequiredFields(values, ['password', 'confirmPassword']);
}
